__turbopack_context__.v({
  "buttonContainer": "page-module__E0kJGG__buttonContainer",
  "contactInfoHome": "page-module__E0kJGG__contactInfoHome",
  "footer": "page-module__E0kJGG__footer",
  "footerInfo": "page-module__E0kJGG__footerInfo",
  "goodsContent": "page-module__E0kJGG__goodsContent",
  "goodsImage": "page-module__E0kJGG__goodsImage",
  "goodsImageContainer": "page-module__E0kJGG__goodsImageContainer",
  "goodsItem": "page-module__E0kJGG__goodsItem",
  "goodsItemLink": "page-module__E0kJGG__goodsItemLink",
  "goodsName": "page-module__E0kJGG__goodsName",
  "goodsPrice": "page-module__E0kJGG__goodsPrice",
  "icon": "page-module__E0kJGG__icon",
  "infoItem": "page-module__E0kJGG__infoItem",
  "latestGoodsContainer": "page-module__E0kJGG__latestGoodsContainer",
  "latestNewsContainer": "page-module__E0kJGG__latestNewsContainer",
  "mobileHiddenGoodsItem": "page-module__E0kJGG__mobileHiddenGoodsItem",
  "mobileVisibleGoodsItem": "page-module__E0kJGG__mobileVisibleGoodsItem",
  "newsContent": "page-module__E0kJGG__newsContent",
  "newsDate": "page-module__E0kJGG__newsDate",
  "newsImage": "page-module__E0kJGG__newsImage",
  "newsImageContainer": "page-module__E0kJGG__newsImageContainer",
  "newsItem": "page-module__E0kJGG__newsItem",
  "newsItemLink": "page-module__E0kJGG__newsItemLink",
  "newsText": "page-module__E0kJGG__newsText",
  "noGoods": "page-module__E0kJGG__noGoods",
  "noNews": "page-module__E0kJGG__noNews",
  "page": "page-module__E0kJGG__page",
  "portfolioImage": "page-module__E0kJGG__portfolioImage",
  "portfolioSlide": "page-module__E0kJGG__portfolioSlide",
  "portfolioSliderContainer": "page-module__E0kJGG__portfolioSliderContainer",
  "portfolioSwiper": "page-module__E0kJGG__portfolioSwiper",
  "visitorCounter": "page-module__E0kJGG__visitorCounter",
});
